import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import { TouchableButton } from '@components/common/Touchable';
import commonStyle from '../serverAppPaymentScreens.module.scss';
import styles from './GiftCardReceiptLandscape.module.scss';

const GiftCardReceiptTileLandscape = ({ item, index, serverAppTheme }) => {
  return (
    <div
      className={cn(styles.cardTile)}
      style={{
        // backgroundColor: index === 1 ? '#E3F2FD' : serverAppTheme?.send_tab_unselected,
        backgroundColor: serverAppTheme?.send_tab_unselected,
      }}
    >
      <div className={styles.cardContent}>
        <div className={styles.cardLeftColumn}>
          <div className={styles.cardName} style={{ color: serverAppTheme?.primary_text }}>
            {item?.name}
          </div>
          <div className={styles.cardStatus} style={{ color: serverAppTheme?.secondary_text }}>
            <span>Status: </span>
            <span>{item?.status === 'Swiped' ? 'Swiped' : (item?.status || 'Swiped')}</span>
            <span className={styles.statusSpacing}>Message: </span>
            <span>{item?.message ? item?.message : 'NA'}</span>
          </div>
        </div>
        <div className={styles.cardCenterColumn}>
          <div className={styles.cardNumber} style={{ color: serverAppTheme?.primary_text }}>
            {item?.number}
          </div>
        </div>
        <div className={styles.cardRightColumn}>
          <div className={styles.cardAmount} style={{ color: serverAppTheme?.primary_text }}>
            {LABEL().CURRENCY_SYMBOL + item.amount.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

GiftCardReceiptTileLandscape.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
    message: PropTypes.string,
    number: PropTypes.string,
    amount: PropTypes.number,
  }),
  index: PropTypes.number,
  serverAppTheme: PropTypes.shape({
    send_tab_unselected: PropTypes.string,
    primary_text: PropTypes.string,
    secondary_text: PropTypes.string,
  }),
};

GiftCardReceiptTileLandscape.defaultProps = {
  item: {},
  index: 0,
  serverAppTheme: {},
};

const GiftCardReceiptLandscape = ({
  receiptTypes,
  isServerApp,
  handleReceiptPopUpOpen,
  handleCheck,
  serverAppTheme,
  continueGiftCardPayment,
  props,
}) => {
  const giftCards = JSON.parse(window.sessionStorage.getItem('seat'))
    ?.paymentCheck?.cards?.filter(el => el.type === 2 && !el.void) || [];

  return (
    <div className={styles.giftCardReceiptContainer}>
      <div
        className={cn(styles.headerMessage, 'h-10')}
        style={{ color: serverAppTheme?.primary_text }}
      >
        {LABEL().GIFT_CARD_ACTIVATION_MESSAGE}
      </div>
      <div
        className={cn(styles.buttonContainer, 'h-18')}
      >
        {isServerApp && receiptTypes?.sms && (
          <div className={styles.buttonWrapper}>
            <TouchableButton
              type="button"
              className={cn(
                styles.receiptButton,
                'od-primary-btn-bg-color od-primary-btn-font-color'
              )}
              onClick={e => {
                e.preventDefault();
                handleReceiptPopUpOpen('phone');
              }}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
            >
              <div className={cn(commonStyle.divForPayment, styles.buttonContent)}>
                {LABEL().TEXT}
              </div>
            </TouchableButton>
          </div>
        )}
        {isServerApp && receiptTypes?.email && (
          <div className={styles.buttonWrapperWithMargin}>
            <TouchableButton
              type="button"
              className={cn(
                styles.receiptButton,
                'od-primary-btn-bg-color od-primary-btn-font-color'
              )}
              onClick={e => {
                e.preventDefault();
                handleReceiptPopUpOpen('email');
              }}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
            >
              <div className={cn(commonStyle.divForPayment, styles.buttonContent)}>
                {LABEL().GIFTCARD_EMAIL_RECEIPT}
              </div>
            </TouchableButton>
          </div>
        )}

        {isServerApp && receiptTypes?.print && (
          <div className={styles.buttonWrapperWithMargin}>
            <TouchableButton
              type="button"
              className={cn(
                styles.printButton,
                'od-primary-btn-bg-color od-primary-btn-font-color'
              )}
              onClick={e => {
                e.preventDefault();
                handleCheck('print');
              }}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
            >
              <div className={cn(commonStyle.divForPayment, styles.buttonContent)}>
                {LABEL().PRINT}
              </div>
            </TouchableButton>
          </div>
        )}
      </div>
      <div
        className={styles.columnHeaders}
        style={{ color: serverAppTheme?.secondary_text }}
      >
        <span className={cn(styles.headerColumn, styles.headerLeft, 'col-4')}>
          {LABEL().CARDNAME}
        </span>
        <span className={cn(styles.headerColumn, styles.headerCenter, 'col-4')}>
          {LABEL().CARDNUMBER}
        </span>
        <span className={cn(styles.headerColumn, styles.headerRight, 'col-4')}>
          {LABEL().AMOUNT}
        </span>
      </div>
      <div className={cn(styles.cardsContainer, 'h-65')}>
        {giftCards.map((item, index) => (
          <GiftCardReceiptTileLandscape
            key={index}
            item={item}
            index={index}
            serverAppTheme={serverAppTheme}
          />
        ))}
      </div>
      <div
        className={styles.continueButtonContainer}
        style={{ bottom: props.showCheckSeat() ? '80px' : '30px' }}
      >
        <TouchableButton
          type="button"
          className={cn(
            styles.continueButton,
            'od-primary-btn-bg-color od-primary-btn-font-color'
          )}
          onClick={() => {
            if (
              !receiptTypes?.sms &&
              !receiptTypes?.email &&
              !receiptTypes?.print
            ) {
              continueGiftCardPayment(true);
            } else {
              continueGiftCardPayment();
            }
          }}
          style={{
            backgroundColor: serverAppTheme?.secondaryBtn,
            color: serverAppTheme.btn_font_color,
          }}
        >
          <div className={styles.continueButtonText}>
            {LABEL().CONTINUE}
          </div>
        </TouchableButton>
      </div>
    </div>
  );
};

GiftCardReceiptLandscape.propTypes = {
  receiptTypes: PropTypes.shape({
    sms: PropTypes.bool,
    email: PropTypes.bool,
    print: PropTypes.bool,
  }),
  isServerApp: PropTypes.bool,
  handleReceiptPopUpOpen: PropTypes.func,
  handleCheck: PropTypes.func,
  serverAppTheme: PropTypes.shape({
    primary_text: PropTypes.string,
    secondary_text: PropTypes.string,
    secondaryBtn: PropTypes.string,
    btn_font_color: PropTypes.string,
    send_tab_unselected: PropTypes.string,
  }),
  continueGiftCardPayment: PropTypes.func,
  props: PropTypes.shape({
    showCheckSeat: PropTypes.func,
  }),
};

GiftCardReceiptLandscape.defaultProps = {
  receiptTypes: {},
  isServerApp: false,
  handleReceiptPopUpOpen: () => {},
  handleCheck: () => {},
  serverAppTheme: {},
  continueGiftCardPayment: () => {},
  props: {},
};

export default GiftCardReceiptLandscape;
